/**
 * Tabs Section
 * Handles tab navigation and content switching
 */

(function () {
  if (window.TabsLoaded) {
    return;
  }
  window.TabsLoaded = true;

  class Tabs {
    constructor() {
      this.init();
    }

    init() {
      this.initAllSections();
      this.bindShopifyEvents();
    }

    initAllSections() {
      const sections = document.querySelectorAll(
        '.js-section-tabs, .section-tabs',
      );
      sections.forEach((section) => {
        const sectionId = section.dataset.sectionId;
        if (sectionId && !section.dataset.scriptInitialized) {
          section.dataset.scriptInitialized = 'true';
          //console.log(sectionId,'sectionid')
          this.initSection(section);
        }
      });
    }

    initSection(sectionElement) {
    const tabs = sectionElement.querySelectorAll('.section-tabs__tab');
    const tabsContainer = sectionElement.querySelector('.section-tabs__list');
    const leftArrow = sectionElement.querySelector('.section-tabs__arrow--left');
    const rightArrow = sectionElement.querySelector('.section-tabs__arrow--right');
//      if (!tabsContainer) return;
     // console.log(sectionElement,'checkcontainer')
// ---- Arrow + Drag logic (only for .js-section-tabs sections) ----
if (sectionElement.classList.contains('js-section-tabs')) {
  console.log('checkcontainer:', sectionElement);

  const tabs = sectionElement.querySelectorAll('.section-tabs__tab');
  const tabsContainer = sectionElement.querySelector('.section-tabs__list');
  const leftArrow = sectionElement.querySelector('.section-tabs__arrow--left');
  const rightArrow = sectionElement.querySelector('.section-tabs__arrow--right');

  if (!tabsContainer) return;

  // ---- Arrow visibility helper ----
  const updateArrows = () => {
    if (!leftArrow || !rightArrow) return;

    const maxScrollLeft = tabsContainer.scrollWidth - tabsContainer.clientWidth;
    const currentScroll = tabsContainer.scrollLeft;

    leftArrow.style.display = currentScroll <= 5 ? 'none' : 'flex';
    rightArrow.style.display = currentScroll >= maxScrollLeft - 5 ? 'none' : 'flex';
  };

  // ---- Arrow click scrolling ----
  const scrollAmount = 200;
  leftArrow?.addEventListener('click', () => {
    tabsContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });
  rightArrow?.addEventListener('click', () => {
    tabsContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });

  // ---- Drag-to-scroll ----
  let isDragging = false;
  let startX;
  let scrollStart;

  const startDrag = (e) => {
    isDragging = true;
    tabsContainer.classList.add('is-dragging');
    startX = e.pageX || e.touches?.[0].pageX;
    scrollStart = tabsContainer.scrollLeft;
  };

  const duringDrag = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX || e.touches?.[0].pageX;
    const walk = (x - startX) * 1.2; // drag sensitivity
    tabsContainer.scrollLeft = scrollStart - walk;
    updateArrows();
  };

  const stopDrag = () => {
    if (!isDragging) return;
    isDragging = false;
    tabsContainer.classList.remove('is-dragging');
  };

  // Mouse events
  tabsContainer.addEventListener('mousedown', startDrag);
  tabsContainer.addEventListener('mousemove', duringDrag);
  tabsContainer.addEventListener('mouseleave', stopDrag);
  tabsContainer.addEventListener('mouseup', stopDrag);

  // Touch events
  tabsContainer.addEventListener('touchstart', startDrag);
  tabsContainer.addEventListener('touchmove', duringDrag);
  tabsContainer.addEventListener('touchend', stopDrag);

  // ---- Update arrow visibility ----
  tabsContainer.addEventListener('scroll', updateArrows);
  window.addEventListener('resize', updateArrows);
  updateArrows();
}
console.log('tabscheck',tabs);


  // ---- Tab click handling ----
  tabs.forEach((tab) => {
    console.log('clicked',tab);
    tab.addEventListener('click', () => {
      const tabName = tab.dataset.tab;

      // Remove active classes
      sectionElement.querySelectorAll('.section-tabs__tab').forEach((t) =>
        t.classList.remove('section-tabs__tab--active')
      );
      sectionElement.querySelectorAll('.section-tabs__panel').forEach((p) =>
        p.classList.remove('section-tabs__panel--active')
      );
      sectionElement.querySelectorAll('.section-tabs__media').forEach((m) =>
        m.classList.remove('section-tabs__media--active')
      );

      // Activate clicked tab + content
      tab.classList.add('section-tabs__tab--active');
      sectionElement
        .querySelector(`[data-tab-content="${tabName}"]`)
        ?.classList.add('section-tabs__panel--active');
      sectionElement
        .querySelector(`[data-tab-media="${tabName}"]`)
        ?.classList.add('section-tabs__media--active');

      // Center clicked tab in scroll area
      const scrollContainer =
        sectionElement.querySelector('.section-slideshow__tabs-nav-container') ||
        tabsContainer;
      const tabLeft = tab.offsetLeft;
      const tabWidth = tab.offsetWidth;
      const containerWidth = scrollContainer.offsetWidth;
      const scrollPosition = tabLeft - containerWidth / 2 + tabWidth / 2;
      tabsContainer.scrollTo({ left: scrollPosition, behavior: 'smooth' });

      // Update arrows after scroll settles
      setTimeout(updateArrows, 400);
    });
  });
}



    bindShopifyEvents() {
      document.addEventListener('shopify:section:load', (event) => {
        const section = event.target.querySelector(
          '.js-section-tabs, .section-tabs',
        );
        if (section) {
          const sectionId = section.dataset.sectionId;
          if (sectionId && !section.dataset.scriptInitialized) {
            section.dataset.scriptInitialized = 'true';
            this.initSection(section);
          }
        }
      });

      document.addEventListener('shopify:section:unload', (event) => {
        const section = event.target.querySelector(
          '.js-section-tabs, .section-tabs',
        );
        if (section) {
          section.dataset.scriptInitialized = '';
        }
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.tabs = new Tabs();
    });
  } else {
    window.tabs = new Tabs();
  }
})();
